import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'sent-icon',
  styleUrl: 'icon.css',
  scoped: true,
})
export class SentIcon {
  @Prop() width: string = '15';
  @Prop() height: string = '15';

  render() {
    // Sent email icon svg, a paper airplane pointing to the right
    return (
      <svg width={this.width} height={this.height} viewBox="0 0 24 24" fill="auto" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.5 12L3.5 3.5L3.5 20.5L21.5 12Z" stroke="auto" stroke-width="1.5" />
        <path d="M3.5 3.5L12 10.5" stroke="auto" stroke-width="1.5" />
        <path d="M3.5 20.5L12 13.5" stroke="auto" stroke-width="1.5" />
      </svg>
    );
  }
}
